import { useContext } from 'react';
import ConditionalTile from '~/constants/srp/ConditionalTile';
import InventoryContext from '~/context/srp/InventoryContext';

export function useHasNccTile(): boolean {
  const { inventory } = useContext(InventoryContext);

  return (
    inventory.data?.inventory?.conditionalTiles?.some(
      tile => tile.key === ConditionalTile.NewCarConfigurator
    ) ?? false
  );
}

export function useNccTileMetaData() {
  const { inventory } = useContext(InventoryContext);

  return inventory.data?.inventory?.conditionalTiles?.find(
    tile => tile.key === ConditionalTile.NewCarConfigurator
  )?.metaData;
}
